import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';

// material imports
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

// fuse imports
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule, FuseWidgetModule, FuseHighlightModule, FuseDemoModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FakeDbService } from 'app/fake-db/fake-db.service';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AgmCoreModule } from '@agm/core';
import { RbTimepickerModule } from 'rb-material-timepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// toaster imports
import { ToastrService } from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';

// primeng importsgit
import { MultiSelectModule, GalleriaModule, ChartModule, TabViewModule } from 'primeng/primeng';
import { PaginatorModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';

import { RoundProgressModule } from 'angular-svg-round-progressbar';
import {
    MatProgressSpinnerModule, MatBadgeModule, MatRadioModule, MatTooltipModule,
    MatButtonModule, MatIconModule, MatInputModule, MatCheckboxModule, MatSlideToggleModule, MatListModule, MatButtonToggleModule,
    MatAutocompleteModule, MatSelectModule, MatMenuModule, MatFormFieldModule, MatDividerModule, MatPaginatorModule, MatOptionModule,
    MatCardModule, MatDialogModule, MatTableModule, MatExpansionModule, MatDatepickerModule, MatTabsModule, MatStepperModule
} from '@angular/material';
import { DatediffPipe } from './shared/common/helper/datediff.pipe';
import { ProgressBarModule } from 'angular-progress-bar';

import {
    LyThemeModule,
    LY_THEME
} from '@alyle/ui';

import { LyResizingCroppingImageModule } from '@alyle/ui/resizing-cropping-images';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LyTypographyModule } from '@alyle/ui/typography';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';

import { LightboxModule } from 'ngx-lightbox';
/** Import theme */
import { MinimaLight, MinimaDark } from '@alyle/ui/themes/minima';
import { HttpModule } from '@angular/http';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { TreeModule } from 'primeng/tree';

// parse service
import { ParseService } from './shared/common/parse/parse.service';

// authentication module
import { LoginModule } from './main/pages/authentication/login/login.module';
import { RegisterModule } from './main/pages/authentication/register/register.module';
import { SecretModule } from './main/pages/authentication/secret/secret.module';
import { ForgotPasswordModule } from './main/pages/authentication/forgot-password/forgot-password.module';

// common imports
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

// project module
import { ProjectsComponent } from './main/pages/projects/projects.component';
import { ProjectListComponent } from './main/pages/projects/project-list/project-list.component';
import { InformationComponent } from './main/pages/projects/project-create/tabs/information/information.component';
import { AssignedResourcesComponent } from './main/pages/projects/project-create/tabs/assigned-resources/assigned-resources.component';
import { CommentsComponent } from './main/pages/projects/project-create/tabs/comments/comments.component';
import { ReleasedResourcesComponent } from './main/pages/projects/project-create/tabs/released-resources/released-resources.component';
import { ProjectCreateComponent } from './main/pages/projects/project-create/project-create.component';
import { projectRepository } from './main/pages/projects/projectrepository';

// profile module

import { ProfileCropComponent } from './main/pages/profile/tabs/profile-crop/profile-crop.component';

// projects module
import { AddOnsListComponent } from './main/pages/projects/project-create/tabs/add-ons-list/add-ons-list.component';
import { OnHoldProjectListComponent } from './main/pages/projects/onHold-project-list/on-hold-project-list.component';
import { OnGoingProjectListComponent } from './main/pages/projects/onGoing-project-list/on-going-project-list.component';
import { ActivitiesComponent } from './main/pages/projects/project-create/tabs/activities/activities.component';


import { PagesModule } from './main/pages/pages.module';
import { GetReportingToService } from './shared/common/helper/get-reporting-to';
import { SocketService } from './shared/common/helper/socket.service';
import { AddLeaveComponent } from './shared/common/add-leave/add-leave.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PlayVideoComponent } from './shared/common/play-video/play-video.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { OnboardModule } from './main/pages/authentication/onboard/onboard.module';
import { InvitedUserModule } from './main/pages/authentication/invited-user/invited-user.module';
import { InvitingUserComponent } from './shared/common/inviting-user/inviting-user.component';
import { DesktopAppPageModule } from './main/pages/authentication/desktopAppPage/desktop-app-page.module';
import { BacklogComponent } from './main/pages/projects/project-create/tabs/backlog/backlog.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ProjectInformationComponent } from './main/pages/projects/project-create/tabs/project-information/project-information.component';
import { CreateProjectInfoComponent } from './main/pages/projects/project-create/tabs/project-information/create-project-info/create-project-info.component';
import { ResourceAllocationComponent } from './main/pages/projects/project-create/tabs/project-information/resource-allocation/resource-allocation.component';
import { ProjectInformationStepperComponent } from './main/pages/projects/project-create/tabs/project-information-stepper/project-information-stepper.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SharedModule } from './shared/shared.module';
import { CountryReducer } from './store/reducers/country.reducer';
import { StoreModule } from '@ngrx/store';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DatePipe } from '@angular/common';
import { CommonMonthPickerComponent } from './shared/common/common-month-picker/common-month-picker.component';
// import { CommonModule } from '@angular/common';
const appRoutes: Routes = [
    { path: '', redirectTo: '/login', pathMatch: 'prefix' },
    {
        path: 'pages',
        loadChildren: './main/pages/pages.module#PagesModule'
    },
    {
        path: 'invitedUser',
        loadChildren: './main/pages/authentication/invited-user/invited-user.module#InvitedUserModule'
    },
    {
        path: 'forgot-password',
        loadChildren: './main/pages/authentication/forgot-password/forgot-password.module#ForgotPasswordModule'
    },
    {
        path: 'login',
        loadChildren: './main/pages/authentication/login/login.module#LoginModule'
    },
    {
        path: 'onboard-login',
        loadChildren: './main/pages/authentication/onboard/onboard.module#OnboardModule'
    },
    {
        path: 'register',
        loadChildren: './main/pages/authentication/register/register.module#RegisterModule'
    },
];

@NgModule({
    declarations: [
        AppComponent,
        ProjectsComponent,
        ProjectListComponent,
        ProjectCreateComponent,
        ProfileCropComponent,
        InformationComponent,
        AssignedResourcesComponent,
        ReleasedResourcesComponent,
        CommentsComponent,
        DatediffPipe,
        AddOnsListComponent,
        CommonMonthPickerComponent,
        ActivitiesComponent,
        OnGoingProjectListComponent,
        OnHoldProjectListComponent,
        AddLeaveComponent,
        PlayVideoComponent,
        InvitingUserComponent,
        BacklogComponent,
        ProjectInformationComponent,
        CreateProjectInfoComponent,
        ResourceAllocationComponent,
        ProjectInformationStepperComponent
    ],
    imports: [
        StoreModule.forRoot({
            country: CountryReducer,
        }),
        NgxSpinnerModule,
        MultiSelectModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpModule,
        RouterModule.forRoot(appRoutes),
        TranslateModule.forRoot(),
        RbTimepickerModule,
        SharedModule,
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay: 0,
            passThruUnknownUrl: true
        }),
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        }),

        // Bootstrap
        NgbModule,
        GalleriaModule,
        // Material
        MatButtonModule,
        MatIconModule,
        MatMomentDateModule,
        MatInputModule,
        MatCheckboxModule,
        MatTabsModule,
        MatSelectModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatTableModule,
        MatDialogModule,
        MatCardModule,
        MatOptionModule,
        MatPaginatorModule,
        MatMenuModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatButtonToggleModule,
        MatListModule,
        MatSlideToggleModule,
        RoundProgressModule,
        TableModule,
        PaginatorModule,

        // charts imports
        ChartsModule,
        NgxChartsModule,
        MatProgressSpinnerModule,
        MatBadgeModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseWidgetModule,
        FuseProgressBarModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        FuseSharedModule,
        FuseDemoModule,
        FuseHighlightModule,
        // toast
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            preventDuplicates: true,
            enableHtml: true
        }),

        SecretModule,
        LayoutModule,
        LoginModule,
        RegisterModule,
        ForgotPasswordModule,
        PagesModule,
        ProgressBarModule,
        LyThemeModule.setTheme('minima-light'), // or
        LyResizingCroppingImageModule,
        LyButtonModule,
        LyIconModule,
        LyTypographyModule,
        ChartModule,
        LightboxModule,
        MatRadioModule,
        OrganizationChartModule,
        TreeModule,
        TabViewModule,
        MatTooltipModule,
        FlexLayoutModule,
        MatStepperModule,
        NgxMaterialTimepickerModule,
        OnboardModule,
        InvitedUserModule,
        DesktopAppPageModule,
        VirtualScrollerModule,
        NgxIntlTelInputModule,
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
        // DefaultTaskModule,
        // CreateOrganizationModule,
        // CreateLocationModule
    ],

    entryComponents: [
        ProfileCropComponent,
        AddLeaveComponent,
        PlayVideoComponent,
        InvitingUserComponent
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        ParseService,
        BrowserAnimationsModule,
        ToastrService,
        projectRepository,
        GetReportingToService,
        SocketService,
        DatePipe,
        { provide: LY_THEME, useClass: MinimaLight, multi: true },
        { provide: LY_THEME, useClass: MinimaDark, multi: true }
    ],
})
export class AppModule {
}
